/**
 * Reine Logik des Composers (M-011 AD6): @-Abfrage vor dem Cursor, stilles Filtern der Liste, Speicherformat der
 * Erwähnung `@[Name](id)`. Ohne React und ohne DOM, damit sie testbar bleibt.
 */
export interface ErwaehnbarePerson {
  id: string;
  name: string;
}

/**
 * Welche @-Abfrage steht vor dem Cursor? „Danke @Mar|“ liefert { suche: "mar", start: 6 }; sonst null. Ein @ mitten
 * in einem Wort (E-Mail-Adresse) startet keine Liste.
 */
export function erwaehnungsAbfrage(text: string, cursor: number): { suche: string; start: number } | null {
  const bis = text.slice(0, cursor);
  const m = /(?:^|\s)@([^\s@]*)$/.exec(bis);
  if (!m) return null;
  const suche = m[1] ?? "";
  return { suche: suche.toLowerCase(), start: cursor - suche.length - 1 };
}

/** Filtert die @-Liste still nach Name (Teilstring, Groß-/Kleinschreibung egal), höchstens `max` Treffer. */
export function filtereErwaehnbare<T extends { name: string }>(personen: readonly T[], suche: string, max = 6): T[] {
  const s = suche.trim().toLowerCase();
  return personen.filter((p) => s === "" || p.name.toLowerCase().includes(s)).slice(0, max);
}

/**
 * Macht aus dem Eingabetext („Danke @Marta Weiß“) das Speicherformat und die Liste der erwähnten Personen. Nur
 * Personen aus `gewaehlt` (die der Nutzer aus der @-Liste gewählt hat) werden zu Erwähnungen, jede einmal. Ein Name,
 * den der Text nicht mehr enthält, zählt nicht (der Nutzer hat ihn wieder gelöscht). Längere Namen zuerst, damit
 * „Marta Weiß“ nicht von „Marta“ halb ersetzt wird.
 */
export function serialisiereErwaehnungen(
  text: string,
  gewaehlt: readonly ErwaehnbarePerson[],
): { text: string; erwaehnte: string[] } {
  let ergebnis = text;
  const erwaehnte: string[] = [];
  const sortiert = [...gewaehlt].sort((a, b) => b.name.length - a.name.length);
  for (const p of sortiert) {
    const marke = `@${p.name}`;
    const i = ergebnis.indexOf(marke);
    if (i < 0) continue;
    ergebnis = `${ergebnis.slice(0, i)}@[${p.name}](${p.id})${ergebnis.slice(i + marke.length)}`;
    if (!erwaehnte.includes(p.id)) erwaehnte.push(p.id);
  }
  return { text: ergebnis, erwaehnte };
}
